// src/mocks/handlers/user/userCustomersHandler.ts

import { rest } from 'msw';
import userCustomers from '@/mocks/data/userCustomers.json';
import { UserCustomersResponse } from '@/domains/user/user.types';
import { API_ENDPOINTS } from '@/services/api/endpoints';
import { VITE_MSW_BASE_URL } from '@/config';

export const userCustomersHandler = rest.get<UserCustomersResponse>(
  `${VITE_MSW_BASE_URL}${API_ENDPOINTS.USER_CUSTOMERS}`,
  (req, res, ctx) => {
    return res(ctx.status(200), ctx.json(userCustomers));
    // return res(ctx.status(500), ctx.json({ error: 'Internal Server Error' }));
  },
);
